import React, { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, getMe, setAuthToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("mat_token");
    if (!token) { setReady(true); return; }
    getMe()
      .then(setUser)
      .catch(() => setAuthToken(null))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    setAuthToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
